// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.config-loader__center {
  position: absolute;
  top: 50%;
  left: 50%;
}`, "",{"version":3,"sources":["webpack://./src/modules/OrderModule/table-tabs/orderTableTabs.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AACD;;AAEA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;AACD","sourcesContent":[".filter-wrapper {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: baseline;\n}\n\n.config-loader__center {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
